/** @format */
import { smallTablet } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

export const styles = () => css`
    .tableau-dashboard-cookie-notice-container {
        width: 100%;
        height: 60rem;
        max-height: 80rem;
        background-color: var(--colors-surface-inverse);
        display: flex;
        flex-direction: column;
        align-items: center;

        .mpb-logo {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: var(--colors-text-inverse);

            > div {
                margin-bottom: var(--layout-spacing-12);
            }
        }

        .tableau-dashboard-cookie-notice-banner {
            margin-top: auto;
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            background-color: var(--colors-surface-primary);
            padding: var(--layout-spacing-24);

            ${smallTablet(css`
                flex-direction: column;
                justify-content: center;

                > p {
                    margin-bottom: var(--layout-spacing-24);
                }
            `)}

            button {
                text-transform: uppercase;
                white-space: nowrap;
            }
        }
    }
`;
